import { render, staticRenderFns } from "./NavbarUserDropdown.vue?vue&type=template&id=baf57b3e&scoped=true"
import script from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarUserDropdown.vue?vue&type=style&index=0&id=baf57b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf57b3e",
  null
  
)

export default component.exports